// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"493":"d2ee892b","988":"66096486"}[chunkId] + ".chunk.css";
};